import { makeStyles } from 'tss-react/mui'
import { Instance as TinyColor } from 'tinycolor2'

const useStyles = makeStyles<{color: TinyColor}>()((theme, params) => ({
    colorSpace: {
        flexGrow: 1,
        borderRadius: '2px',
        padding: 0,
        width: '150px',
        height: '150px',
        background: params.color.clone().toRgbString(),
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
            content: '\"\"',
            position: 'absolute',
            height: '100%',
            width: '100%',
            top: 0,
            left: 0,
            zIndex: 1,
            background: 'linear-gradient(90deg,#fff,transparent)'
        },
        '&::after': {
            content: '\"\"',
            position: 'absolute',
            height: '100%',
            width: '100%',
            top: 0,
            left: 0,
            zIndex: 2,
            background: 'linear-gradient(0deg,#000,transparent)'
        }
    },
    colorPointer: {
        position: 'absolute',
        height: '14px',
        width: '14px',
        borderRadius: '50%',
        border: "2px solid #fff",
        transform: 'translate(-7px, -7px)',
        zIndex: 3
    },
    hueSliderContainer: {
        width: '28px',
        height: '150px',
        display: 'flex',
        justifyContent: 'center',
    },
}))

export default useStyles